import(/* webpackMode: "eager", webpackExports: ["SearchAgainBar"] */ "/app/components/comparison/SearchAgainBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
